import React from 'react';
import { Dialog, DialogContent, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

interface ResumeDialogProps {
  open: boolean;
  onClose: () => void;
}

interface Certification {
  name: string;
  period: string;
}

interface CertificationSet {
  name: string;
  certifications: Certification[];
}

const ResumeDialog: React.FC<ResumeDialogProps> = ({ open, onClose }) => {
  const certifications: CertificationSet[] = [
    { name: 'IT系', certifications: [
      { name: '基本情報技術者試験合格', period: '2018-??' },
      { name: '応用情報技術者試験合格', period: '2024-??' },
      { name: 'ネットワークスペシャリスト試験合格？', period: '2025-07' },
    ] },
    { name: 'ファイナンス系', certifications: [
      { name: '簿記3級', period: '????-??' },
      { name: 'FP2級', period: '????-??' },
      { name: 'AFP', period: '????-??' },
    ] },
    { name: 'その他資格', certifications: [
      { name: '化粧品成分検定1級合格・化粧品成分上級スペシャリスト', period: '2024-12' },
    ] },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogContent>
        {certifications.map((category) => (
          <div key={category.name}>
            <Typography variant="h6" sx={{ mt: 1, mb: 1, fontWeight: 'bold' }}>{category.name}</Typography>
            <List>
              {category.certifications.map((cert, index) => (
                <ListItem key={index}>
                  <ListItemText 
                    primary={cert.name} 
                    secondary={cert.period && `${cert.period}`} 
                  />
                </ListItem>
              ))}
            </List>
            <Divider sx={{ my: 1 }} />
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};



export default ResumeDialog; 